import { ListChecks, SealCheck, ShieldCheck, Scales, Sparkle } from "@phosphor-icons/react";

const num = (v) => (v && typeof v === "object" ? (v.count || 0) : (v || 0));

// Single source of truth for "work waiting on you" — shared by the Dashboard
// summary bar and the Action Inbox so their counts and grouping always match.
// Journals due + overdue are deliberately grouped into one "Journals to post"
// item (that's exactly what "Post now" acts on).
export function buildInbox(data) {
  if (!data) return [];
  const overdue = num(data.journals_overdue);
  const due = num(data.journals_due);
  // Postable now (matches the Close page + scheduler): dated on/before the posting cut-off.
  // Falls back to due+overdue only if the backend hasn't supplied the precise figure.
  const post = data.journals_to_post != null ? data.journals_to_post : (overdue + due);
  return [
    { key: "review", label: "Items to review", short: "to review",
      desc: "Unscheduled prepayments & accruals waiting to be scheduled.",
      count: num(data.unscheduled_count), to: "/unscheduled", icon: ListChecks },
    { key: "post", label: "Journals to post", short: "to post",
      desc: "Release journals that are due or overdue for posting.",
      count: post, overdueCount: overdue, urgent: overdue > 0,
      to: "/close", icon: SealCheck },
    { key: "approvals", label: "Approvals waiting", short: "approvals",
      desc: "Journals queued for 2-person approval before posting.",
      count: num(data.approvals_waiting), to: "/approvals", icon: ShieldCheck },
    { key: "variances", label: "Reconciliation variances", short: "variances",
      desc: "Balances that don't yet tie back to the register.",
      count: num(data.reconciliation_variances), to: "/reconciliation", icon: Scales },
    { key: "recurring", label: "Recurring-accrual suggestions", short: "suggestions",
      desc: "Suggested recurring accruals ready to review.",
      count: num(data.recurring_suggestions), to: "/recurring-accruals", icon: Sparkle },
  ];
}

export function inboxOutstanding(data) {
  return buildInbox(data).filter((i) => i.count > 0);
}

export function inboxTotal(data) {
  return buildInbox(data).reduce((s, i) => s + i.count, 0);
}

// The single highest-priority thing to do next (drives the "Start here" button).
export function nextAction(data) {
  const order = ["post", "review", "approvals", "variances", "recurring"];
  const items = buildInbox(data);
  for (const key of order) {
    const it = items.find((i) => i.key === key);
    if (it && it.count > 0) return it;
  }
  return null;
}
